// components/ui/listt/header-cell-text.js
import { Typography } from '@mui/material';

const HeaderCellText = ({ children, sx = {}, ...rest }) => (
  <Typography
    sx={{
      fontWeight: 500,
      fontSize: '0.675rem',
      lineHeight: 1.66,
      textTransform: {
        xs: 'none',
        sm: 'uppercase',
      },
      color: 'neutral.600',
      p: 0,
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Typography>
);

export default HeaderCellText;
